import { useEffect } from 'react';
import { useStoreActions, useStoreState } from '../store';
import { usePartner } from './queries/usePartner';

/**
 * Hook to synchronize TanStack Query data with Easy Peasy store for backward compatibility.
 * This keeps the existing 77+ components that depend on store state working while
 * providing better caching and performance through TanStack Query.
 */
export const useStoreSync = () => {
  const sessionPartnerId = useStoreState((state) => state.session.user?.sessionPartnerId);

  // TanStack Query hooks
  const partnerQuery = usePartner({ partnerId: sessionPartnerId || '' });

  // Easy Peasy store actions
  const setActivePartner = useStoreActions((actions) => actions.partner.setActivePartner);

  // Sync TanStack Query data to Easy Peasy store
  useEffect(() => {
    if (partnerQuery.data) {
      setActivePartner(partnerQuery.data);
    }
  }, [partnerQuery.data, setActivePartner]);

  return {
    partnerQuery,
  };
};
